(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kmc-bundle-landing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kmc-bundle-landing')) {
  customElements.define('kmc-bundle-landing', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const selector = this.querySelector('[data-variant]');
      if (!selector) return;
      const update = () => {
        const option = selector.selectedOptions[0];
        if (!option) return;
        this.querySelector('[data-price]').textContent = option.dataset.price;
        this.querySelector('[data-savings]').textContent = option.dataset.saving;
        this.querySelector('[data-sticky-price]').textContent = option.dataset.price;
        this.querySelector('[data-sticky-caption]').textContent = option.dataset.title + ' · ' + option.dataset.price;
        const button = this.querySelector('[data-buy]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? this.dataset.unavailableLabel : this.dataset.addLabel;
      };
      selector.addEventListener('change', update);
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kmc-flash-sale"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('kmc-flash-sale')) {
  customElements.define('kmc-flash-sale', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('time[datetime]').forEach(el => {
        const date = new Date(el.dateTime);
        if (Number.isFinite(date.getTime())) el.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {month:'short', day:'numeric', hour:'numeric', minute:'2-digit', timeZoneName:'short'}).format(date);
      });
      if (this.dataset.editor === 'true' || this.dataset.enabled !== 'true') return;
      const check = () => {
        const start = this.dataset.start ? Date.parse(this.dataset.start) : -Infinity;
        const end = this.dataset.end ? Date.parse(this.dataset.end) : Infinity;
        const active = Date.now() >= start && Date.now() < end;
        if (active !== (this.dataset.active === 'true')) {
          const key = 'kmc-flash-refresh-' + this.dataset.start + this.dataset.end + active;
          try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); } catch(e) { return; }
          window.location.reload();
        }
      };
      check(); this.timer = setInterval(check, 15000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
